const resizeWidgets = function() {
    const widgetEl = $('#widgets');
    if (!widgetEl.length) {
        return;
    }

    const widgetCount = widgetEl.find('.widget:visible').length;
    const cols = Math.round(widgetEl.width() / widgetEl.find('.widget').first().outerWidth());
    const leftEls = cols - (widgetCount % cols);

    document.querySelector('#widgets .ghost-item').style.flexBasis = `${leftEls * 100 / cols}%`;
};

export default resizeWidgets;
